module.exports = __webpack_public_path__ + "static/media/google.9ad5d691.svg";